// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__tkdMX","content":"LayoutSettings_content__TL5aI"};